import type { KeyValueStore } from '@bsync/sync-engine';
import { createStore, del, get, set } from 'idb-keyval';

/** IndexedDB-backed persistence for the dashboard's replica and outbox (works offline). */
export class IdbStore implements KeyValueStore {
  private readonly db = createStore('bsync', 'kv');
  constructor(private readonly prefix: string) {}
  get<T>(key: string) {
    return get<T>(this.prefix + key, this.db);
  }
  set<T>(key: string, value: T) {
    return set(this.prefix + key, value, this.db);
  }
  remove(key: string) {
    return del(this.prefix + key, this.db);
  }
}
